/* eslint-disable import/order */
import { planDependenciesReportEntryPoint } from '@jira/spa-apps__advanced-roadmaps-plan-dependencies-report/src/planDependenciesReportEntryPoint.entrypoint.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { arjDependenciesEmbedRoute } from '@jira/router-routes__advanced-roadmaps-embed-routes/src/arjDependenciesEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { PlanDependenciesReportEmbedPage, LazyPlanDependenciesReportEmbed } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const planDependenciesReportEmbedRouteEntry = createChromelessEntryPoint({
	main: planDependenciesReportEntryPoint,
});

export const arjDependenciesEmbedRouteEntry: Route = createEntry(arjDependenciesEmbedRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: PlanDependenciesReportEmbedPage,

	entryPoint: () => planDependenciesReportEmbedRouteEntry,

	layout: createLayout({
		isChromeless: true,
	}),

	resources: [
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		...jiraSpaResources(),
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	forPaint: [LazyPlanDependenciesReportEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
